module.exports = __webpack_public_path__ + "img/logo51.115cdc49.png";